import { render, staticRenderFns } from "./ShowCard.vue?vue&type=template&id=31e748be&scoped=true"
import script from "./ShowCard.vue?vue&type=script&lang=js"
export * from "./ShowCard.vue?vue&type=script&lang=js"
import style0 from "./ShowCard.vue?vue&type=style&index=0&id=31e748be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e748be",
  null
  
)

export default component.exports